import { isNil } from 'ramda';
import { useQuery } from 'react-query';

import { createOptions } from '../utils';

import { getCLAYearSettings, getDccOptions } from 'RestAPIs/admin';
import { getDutyHourTypesByDcc } from 'RestAPIs/dutyHourTypes';

export const useGetCLASettings = (options?: Record<string, unknown>) =>
  useQuery(
    ['claYears'],
    async () => {
      const { data } = await getCLAYearSettings();
      if (isNil(data)) return [];
      return data;
    },
    options
  );

export const useGetDhtOptions = (options?: Record<string, unknown>) =>
  useQuery(
    ['DHTClaSettings', 'list'],
    async () => {
      const { data } = await getDutyHourTypesByDcc();
      if (isNil(data)) return [];
      return data.map((dcc) => {
        return {
          value: dcc.id,
          label: dcc.description
        };
      });
    },
    options
  );

export const useGetDccOptions = (options?: Record<string, unknown>) =>
  useQuery(
    ['duty-calculation-codes'],
    async () => {
      const { data } = await getDccOptions();
      if (isNil(data)) return [];
      return createOptions(data);
    },
    options
  );
